import React, { Component } from "react";
import "./css/calBattenPc.css";

import HorizonImage from "./src/Horizon.png";
import VerticalImage from "./src/Vertical.png";
import ExitIcon from "./src/exit.png";

export default class calBattenPc extends Component {
  state = {
    dataA: 0,
    dataB: 0,
    dataC: 0,
    horizon: true,
    onAlert: false,

    resultCalculate: 0,
    onResult: false,
  };

  onSelectAxis = (value) => {
    this.setState({ horizon: value });
  };

  handleChangeA = (event) => {
    const value = event.target.value;
    this.setState({ dataA: value });
  };

  handleChangeB = (event) => {
    const value = event.target.value;
    this.setState({ dataB: value });
  };

  handleChangeC = (event) => {
    const value = event.target.value;
    this.setState({ dataC: value });
  };

  handleFocus = (event) => {
    event.target.select();
    this.setState({ onAlert: false });
  };

  onChangeSelect = (event) => {
    this.props.onSelect(event.target.selectedIndex + 1);
  };

  onHideAlert = () => {
    this.setState({ onAlert: false });
  };

  onHideResult = () => {
    this.setState({ onResult: false });
  };

  onClose = () => {
    this.onHideResult();
    this.props.onClose();
  };

  componentDidUpdate = (prevState) => {
    if (prevState.currentBatten.id !== this.props.currentBatten.id) {
      this.setState({ onResult: false });
    }
  };

  onCalculate = () => {
    if (
      Number(this.state.dataA) <= 0 ||
      Number(this.state.dataB) <= 0 ||
      Number(this.state.dataC) <= 0
    ) {
      this.setState({ onAlert: true });
    } else {
      const floatCalculate = Math.ceil(
        (Number(this.state.dataA) + (Number(this.state.dataC) * 2.545) / 100) *
          (1 /
            (((Number(this.props.currentBatten.width) +
              Number(this.state.dataC)) *
              2.545) /
              100)) *
          Number(this.state.dataB) *
          (1 / 3)
      );

      this.setState({ resultCalculate: floatCalculate });
      this.setState({ onResult: true });
    }
  };

  render() {
    return (
      <div className="calculate-pc-batten-container">
        <div
          className="calculate-pc-batten-close-container"
          onClick={this.onClose}
        >
          <img className="calculate-pc-batten-close" src={ExitIcon} alt="" />
        </div>
        <div
          className={
            this.state.onAlert
              ? "alert alert-danger calculate-batten-alert p-2"
              : "alert alert-danger calculate-batten-alert p-2 calculate-batten-hide"
          }
          role="alert"
          onClick={this.onHideAlert}
        >
          กรุณากรอกข้อมูลให้ครบถ้วน และมีค่ามากกว่าศูนย์
        </div>
        <div className="calculate-pc-batten-input-container">
          <div className="calculate-pc-batten-axis-container">
            <img
              className={
                this.state.horizon
                  ? "calculate-pc-batten-axis-image-horizon"
                  : "calculate-pc-batten-axis-image-vertical"
              }
              src={this.state.horizon ? HorizonImage : VerticalImage}
              alt=""
            />

            <div className="calculate-pc-batten-axis-menu-container">
              <div
                className={
                  this.state.horizon
                    ? "calculate-pc-batten-axis-menu-select"
                    : "calculate-pc-batten-axis-menu-unselect"
                }
                onClick={() => this.onSelectAxis(true)}
              >
                แนวนอน
              </div>
              <div
                className={
                  this.state.horizon
                    ? "calculate-pc-batten-axis-menu-unselect"
                    : "calculate-pc-batten-axis-menu-select"
                }
                onClick={() => this.onSelectAxis(false)}
              >
                แนวตั้ง
              </div>
            </div>
          </div>

          <div className="calculate-pc-batten-select">
            <select
              className="form-select form-select-sm calculate-batten-select"
              aria-label="Default select example"
              value={this.props.currentBatten.id}
              onChange={this.onChangeSelect}
            >
              {this.props.dataBatten
                .sort((a, b) => a.id - b.id)
                .map((data) => (
                  <option key={data.id} value={data.id}>
                    {data.name} {data.size}
                  </option>
                ))}
            </select>
          </div>

          <div className="calculate-batten-text-require">
            <div className="calculate-batten-text-require-front">
              กรอกข้อมูล
            </div>
            <div className="calculate-batten-text-require-bar" />
            <div>กรุณากรอกข้อมูลให้ครบถ้วน</div>
          </div>

          <div className="calculate-batten-input-group">
            <div className="calculate-batten-input">
              <div className="calculate-batten-input-text">A</div>
              <div className="calculate-batten-input-text-star">*</div>
              <input
                type="number"
                className="form-control"
                style={{ marginRight: "5%" }}
                placeholder="เมตร"
                min="1"
                max="5"
                onChange={this.handleChangeA}
                onFocus={this.handleFocus}
              />
            </div>

            <div className="calculate-batten-input">
              <div className="calculate-batten-input-text">B</div>
              <div className="calculate-batten-input-text-star">*</div>
              <input
                type="number"
                className="form-control"
                style={{ marginRight: "5%" }}
                placeholder="เมตร"
                min="1"
                max="5"
                onChange={this.handleChangeB}
                onFocus={this.handleFocus}
              />
            </div>

            <div className="calculate-batten-input">
              <div className="calculate-batten-input-text">C</div>
              <div className="calculate-batten-input-text-star">*</div>
              <input
                type="number"
                className="form-control"
                style={{ marginRight: "5%" }}
                placeholder="นิ้ว"
                min="1"
                max="5"
                onChange={this.handleChangeC}
                onFocus={this.handleFocus}
              />
            </div>

            <div className="calculate-batten-button-container">
              <button
                className="calculate-batten-button"
                onClick={this.onCalculate}
              >
                <div className="calculate-batten-button-text">คำนวณ</div>
              </button>
            </div>
          </div>
        </div>
        <div
          className={
            this.state.onResult
              ? "calculate-pc-batten-result-container-show"
              : "calculate-pc-batten-result-container-hide"
          }
        >
          <div className="calculate-pc-batten-result-image">
            <img
              className={
                this.state.horizon
                  ? "calculate-pc-batten-axis-image-horizon"
                  : "calculate-pc-batten-axis-image-vertical"
              }
              src={this.state.horizon ? HorizonImage : VerticalImage}
              alt=""
            />
          </div>

          <div className="calculate-batten-result-text">
            <div className="calculate-batten-result-text-front">ผลการคำนวณ</div>
            <div className="calculate-batten-result-text-back">
              จำนวน {this.state.resultCalculate} ชิ้น
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-sm-auto">
                <img
                  className="calculate-pc-batten-result-info-body-icon"
                  src={this.props.currentBatten.iconlink}
                  alt=""
                />
              </div>
              <div className="col">
                <div
                  className="calculate-batten-result-info-header"
                  style={{ margin: "0px" }}
                >
                  <div className="row calculate-batten-result-header-text">
                    {this.props.currentBatten.name}
                  </div>
                </div>

                <div className="row">
                  <table className="table table-borderless">
                    <thead style={{ backgroundColor: "#E6E7E8" }}>
                      <tr>
                        <th scope="col">รุ่น</th>
                        <th scope="col">ลาย</th>
                        <th scope="col">สี</th>
                        <th scope="col">
                          <div>ขนาด (ซม.)</div>
                          <div>(หนา * กว้าง * ยาว)</div>
                        </th>
                        <th scope="col">
                          <div>จำนวน</div>
                          <div>(แผ่น/ตร.ม.)</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody style={{ backgroundColor: "white" }}>
                      {this.props.dataBatten.map((data) =>
                        data.id === this.props.currentBatten.id ? (
                          <tr key={data.id}>
                            <th scope="col">{data.class}</th>
                            <th scope="col">{data.striped}</th>
                            <th scope="col">{data.color}</th>
                            <th scope="col">{data.size}</th>
                            <th scope="col">{data.numpersqm}</th>
                          </tr>
                        ) : null
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div className="calculate-batten-button-container">
            <button
              className="calculate-batten-button"
              onClick={this.onHideResult}
            >
              <div className="calculate-batten-button-text">คำนวณใหม่</div>
            </button>
          </div>
        </div>
      </div>
    );
  }
}
